import { useEffect } from 'react'
import { Route, Routes as RouterRoutes } from 'react-router-dom'

import { useHandleCreditBuilderSunset } from '../hooks/credit-builder/use-handle-credit-builder-sunset'
import { Delegate } from '../views/pages/auth/Delegate'
import { DevAuthContainer } from '../views/pages/auth/DevAuthContainer'
import { PhoneConsolidationContainer } from '../views/pages/auth/PhoneConsolidationContainer'
import { PhoneNumberContainer } from '../views/pages/auth/PhoneNumberContainer'
import { OnboardingConfirmPinContainer } from '../views/pages/onboarding/auth/OnboardingConfirmPinContainer'
import * as Routes from './constants'
import { getRouteSlugs } from './utils'

const routeSlugs = getRouteSlugs(Routes.App.AUTH, Routes.Auth)

export function AuthRoutes() {
  const { checkShouldRedirect } = useHandleCreditBuilderSunset()

  useEffect(() => {
    checkShouldRedirect()
  }, [])

  return (
    <RouterRoutes>
      <Route path={routeSlugs.PHONE} Component={PhoneNumberContainer} />
      <Route path={routeSlugs.DELEGATE} Component={Delegate} />
      <Route path={routeSlugs.PHONE_CREATE_ACCOUNT} Component={PhoneConsolidationContainer} />
      <Route path={routeSlugs.PIN} Component={OnboardingConfirmPinContainer} />
      <Route path={routeSlugs.DEV} Component={DevAuthContainer} />
    </RouterRoutes>
  )
}
